
import { defineComponent, PropType } from "vue";
import MediaDisplay from "@/components/alerts/MediaDisplay.vue";
import { formatDateTime } from "@/components/alerts/utils/alertFormatters";
import { getMessageTypeLabel } from "@/components/alerts/utils/alertStatus";
import { TelegramMessageUI } from "@/stores/telegramAlerts";
import { useAlertPermissions } from "@/composables/useAlertPermissions";

export default defineComponent({
  name: "OrphanedMessages",
  components: {
    MediaDisplay,
  },
  props: {
    messages: {
      type: Array as PropType<TelegramMessageUI[]>,
      default: () => [],
    },
    isReprocessing: {
      type: Object as PropType<Record<number, boolean>>,
      default: () => ({}),
    },
  },
  emits: ["reprocess", "open-link-modal"],
  setup() {
    const { canReanalyzeAlerts, canLinkMessages } = useAlertPermissions();

    return {
      formatDateTime,
      getMessageTypeLabel,
      canReanalyzeAlerts,
      canLinkMessages,
    };
  },
});
